<ng-container *transloco="let t">
    <h2 mat-dialog-title>{{ t('EXPORT-NOTICE-TITLE') }}</h2>

    <mat-dialog-content>
        <p class="mb-4">{{ t('EXPORT-NOTICE-TEXT') }}</p>

        @if (data.passwordOption) {
            <mat-form-field class="w-full">
                <mat-label>{{ t('EXPORT-NOTICE-PASSWORD') }}</mat-label>
                <input
                    matInput
                    type="password"
                    autocomplete="new-password"
                    [(ngModel)]="password"
                    (keydown.enter)="confirm()"
                />
                <mat-hint>{{ t('EXPORT-NOTICE-PASSWORD-HINT') }}</mat-hint>
            </mat-form-field>

            @if (passwordTooShort) {
                <p class="mt-2 text-sm text-red-600">
                    {{ t('EXPORT-NOTICE-PASSWORD-TOO-SHORT', { min: minLength }) }}
                </p>
            }
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" [mat-dialog-close]="null">
            {{ t('CANCEL') }}
        </button>
        <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="passwordTooShort"
            (click)="confirm()"
        >
            {{ t('DOWNLOAD') }}
        </button>
    </mat-dialog-actions>
</ng-container>
